export default __webpack_public_path__ + "images/personal_baggage.f919f6e.svg";